import React, { useState } from 'react';

import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import PrimaryButton from '../ui/buttons/primaryButton';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import PlayersPanel from './playersPanel';

// Button + dialog that opens the players list (add/edit/remove/swap)
// without listing players inline in the calling component.
const ViewPlayersDialog = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <PrimaryButton
        variant="outlined"
        color="primary"
        startIcon={<PersonIcon />}
        onClick={() => setOpen(true)}>
        View Players
      </PrimaryButton>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Players
          <IconButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <PlayersPanel />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewPlayersDialog;
